<template>
  <div :class="classInput">
    <div class="form-group">
      <label class="label" :class="{'required': isRequired}">{{ label }}</label>
      <input
        :value="isoValue"
        type="date"
        class="form-control"
        :class="{'is-invalid': isInvalid}"
        @blur="() => validate()"
        @input="inputHandle($event)"
      >
      <div
        v-if="isInvalid"
        class="invalid-feedback"
      >
        <span v-if="isInvalid">Data obrigatória.</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    typeInput: {
      type: String
    },
    value: {
      type: String
    },
    classInput: {
      type: String,
      required: true
    },
    isRequired: {
      type: Boolean,
      default: true
    },
    forceShowError: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isInvalid: false,
      hasTouched: false
    }
  },
  computed: {
    isoValue () {
      if (!this.value) return ''
      // Se já está em YYYY-MM-DD, retorna direto
      if (/^\d{4}-\d{2}-\d{2}/.test(this.value)) {
        return this.value.substring(0, 10)
      }
      // Converte DD/MM/YYYY para YYYY-MM-DD
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(this.value)) {
        var parts = this.value.split('/')
        return parts[2] + '-' + parts[1] + '-' + parts[0]
      }
      return this.value
    }
  },
  watch: {
    forceShowError (newVal) {
      if (newVal) {
        this.validate()
      }
    }
  },
  methods: {
    inputHandle (e) {
      this.hasTouched = true
      var isoVal = e.target.value

      if (this.isInvalid && isoVal && isoVal !== '') {
        this.isInvalid = false
      }

      // Emite sempre em YYYY-MM-DD (formato ISO)
      this.$emit('input', isoVal)
    },
    validate () {
      var shouldValidate = this.hasTouched || this.forceShowError
      this.isInvalid = shouldValidate && this.isRequired && (!this.value || this.value === '')
    },
    isValid () {
      this.validate()
      return !this.isInvalid
    }
  }
}
</script>
